import gql from 'graphql-tag';

export const GET_GROUP_AFFILIATION_PROMOTION = gql`
  query getGroupAffiliationPromotion($storeCode: String!) {
    promotion {
      groupAffiliationPromotion(storeCode: $storeCode) {
        applied
        eligibleGroups
        promotion {
          title
          description
          detailsUrl
          discount {
            formattedValue
          }
          firedMessages
        }
        verificationDiscountAppliedMessage
        verificationSuccessMessage
        verificationSuccessTooltipMessage
        verifiedGroup
        willBeApplied
      }
    }
  }
`;
